import React, { useEffect, useState } from 'react'
import './App.css'
import './Previewtickets.css'
import { Link, Redirect, useLocation, useHistory } from 'react-router-dom'
import Axios from 'axios'
import ClipLoader from 'react-spinners/ClipLoader'
import { IoIosArrowBack } from 'react-icons/io'
import {
  IoCalendarOutline,
  IoLocationOutline,
  IoTimeOutline,
  IoTicketOutline,
  IoInformationCircleOutline,
  IoWarningOutline,
} from 'react-icons/io5'
import md5 from 'md5'
import Header from './layouts/Header'
import { BiMenu, BiChevronRight } from 'react-icons/bi'
import SideNavCust from './layouts/SideNavCust'
import { API_URL } from './config'
// import QRCode from "qrcode.react";
var QRCode = require('qrcode.react')

const Previewtickets = () => {
  const baseURL = `${API_URL}/apps/kscanner/webservices.php`
  const location = useLocation()
  const history = useHistory()
  const [query, setQuery] = useState('')
  const [password, setPassword] = useState('')
  const [response, setResponse] = useState('')
  const [error, setError] = useState('')
  const [errorDisplay, setErrorDisplay] = useState('none')
  const [previews, setPreviews] = useState([])
  const [maxAttemtps, setMaxAttempts] = useState(0)
  const [loading, setLoading] = useState(true)
  const [loadingAttempts, setLoadingAttempts] = useState(true)
  const [refundsAllowed, setRefundsAllowed] = useState(0)
  const [postponedCancelled, setPostponedCancelled] = useState('no')
  const [postponed, setPostponed] = useState('no')
  const [cancelled, setCancelled] = useState('no')

  const isMobile = window.innerWidth <= 768
  const [isMob, setIsMob] = useState()
  const [collapsed, setCollapsed] = useState(isMobile)

  const customername = localStorage.getItem('customername')
  const eventname = location.state?.eventname || ''

  const updateIsMobile = () => {
    const mobile = window.innerWidth <= 768
    setIsMob(mobile)
    setCollapsed((prev) => (mobile ? true : prev))
  }

  useEffect(() => {
    if (localStorage.getItem('customername') === null) {
      return <Redirect to="/login" />
      //   return exit(1);
    } else {
    }
    const customername = localStorage.getItem('customername')
    const customerid = localStorage.getItem('customerid')
    const eventid = location.state?.eventid

    if (customername) {
      document.title = customername
    }

    Axios.get(`${baseURL}?query=GET-REFUND-GOVERNANCE-RULES&eventid=${eventid}`, {
      withCredentials: true,
    })
      .then((response) => {
        setMaxAttempts(response.data.maxAttempts ?? 2)
        setRefundsAllowed(response.data.refundsAllowed)
        setPostponedCancelled(response.data.postponedCancelled ?? 'no')
        setPostponed(response.data.isPostponed ?? 'no')
        setCancelled(response.data.isCancelled ?? 'no')
        setTimeout(() => {
          setLoadingAttempts(false)
        }, 1000)
      })
      .catch((error) => {
        alert(error)
        console.log(error)
      })

    if (customerid && eventid) {
      Axios.get(
        `${API_URL}/apps/kscanner/webservices.php?query=PREVIEWTICKETS&customerid=${customerid}&eventid=${eventid}`,
        {
          withCredentials: true,
        },
      )
        .then((response) => {
          const data = response.data
          // console.log(data.length);
          setPreviews(response.data ?? [])
          setTimeout(() => {
            setLoading(false)
          }, 1000)
        })
        .catch((error) => console.error('Preview fetch error:', error))
    }

    updateIsMobile()
    window.addEventListener('resize', updateIsMobile)

    return () => {
      // this runs on unmount
      window.removeEventListener('resize', updateIsMobile)
    }
  }, [location.state, setPreviews])

  const refund = (
    ticket_id,
    ticket_number,
    event_name,
    event_id,
    refund_status,
    m_payment_id,
    refund_attempts,
    maxAttempts,
  ) => {
    history.push({
      pathname: '/ticket-refund',
      state: {
        ticket_id,
        ticket_number,
        event_name,
        event_id,
        refund_status,
        m_payment_id,
        refund_attempts,
        maxAttempts,
      },
    })
  }

  const getTickets = () => {
    const customerid = localStorage.getItem('customerid')
    const customername = localStorage.getItem('customername')
    const eventid = location.state?.eventid
    const transactiondate = location.state?.transactiondate
    const venue = location.state?.venue
    const eventname = location.state?.eventname
    const eventtime = location.state?.eventtime
    const eventday = location.state?.eventday
    const yearcreated = location.state?.yearcreated
    const theme = location.state?.theme
    const admissions = location.state?.admissions
    const totalcost = location.state?.totalcost
    let category = ''

    return (
      <div>
        {loading ? (
          <div className="pv-list">
            {[0, 1].map((i) => (
              <div className="pv-card pv-card--skeleton" key={i}>
                <div className="pv-card__main">
                  <div className="pv-qr pv-skel" />
                  <div className="pv-info">
                    <div className="pv-skel pv-skel--title" />
                    <div className="pv-skel pv-skel--line" />
                    <div className="pv-skel pv-skel--line" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <>
            {previews.length < 1 ? (
              <div className="pv-empty">
                <div className="pv-empty__icon">
                  <IoTicketOutline size={28} />
                </div>
                <h3>No data found</h3>
              </div>
            ) : (
              <div className="pv-list">
                {previews.map((item, index) => {
                  let attempts =
                    item.refund_status !== null
                      ? Number(item.refundAttempts) + 1
                      : item.refundAttempts

                  {
                    item.category == 'general'
                      ? (category = 'General')
                      : (category = item.category.toUpperCase())
                  }

                  const adminBlocked = Number(item.admin_disabled) === 1

                  const isVoid =
                    adminBlocked ||
                    item.refund_status === 'Approved' ||
                    item.refund_status === 'Pending' ||
                    item.refund_status === 'Under_review'

                  const refundHidden = refundsAllowed == 0 && postponedCancelled === 'no'

                  return (
                    <article className={`pv-card ${isVoid ? 'pv-card--void' : ''}`} key={index}>
                      {item.refund_status === 'Approved' ? (
                        <div className="pv-note pv-note--warn">
                          <IoInformationCircleOutline size={16} />
                          <span>This ticket has been refunded and is no longer valid.</span>
                        </div>
                      ) : item.refund_status === 'Pending' ||
                        item.refund_status === 'Under_review' ? (
                        <div className="pv-note pv-note--info">
                          <IoInformationCircleOutline size={16} />
                          <span>
                            {item.refund_status === 'Under_review'
                              ? "Refund request under review. We'll notify you once a decision is made."
                              : 'Refund request submitted. Awaiting review.'}
                          </span>
                        </div>
                      ) : adminBlocked ? (
                        <div className="pv-note pv-note--warn">
                          <IoInformationCircleOutline size={16} />
                          <span>
                            This ticket has been disabled by Karamale and cannot be used. Please
                            contact Karamale support.
                          </span>
                        </div>
                      ) : (
                        ''
                      )}

                      <Link
                        to={{
                          pathname: '/zoom',
                          state: {
                            customername: customername,
                            customerid: customerid,
                            eventid: eventid,
                            transactiondate: transactiondate,
                            venue: venue,
                            eventname: eventname,
                            eventtime: eventtime,
                            eventday: eventday,
                            yearcreated: yearcreated,
                            theme: theme,
                            admissions: admissions,
                            totalcost: totalcost,
                            ticketnumber: item.ticketnumber,
                            refund_status: item.refund_status,
                          },
                        }}
                        className="pv-card__main"
                      >
                        <div className="pv-qr">
                          <QRCode
                            value={isVoid ? md5(item.ticketnumber) : (item.qr_payload ?? '')}
                            logoSize={30}
                            fgColor={isVoid ? 'grey' : '#000'}
                            bgColor={'#fff'}
                            className={'preview_tickets_qrcode'}
                          />
                          {/* <QRCode
                            value={
                              item.refund_status === 'Approved' ||
                              item.refund_status === 'Pending' ||
                              item.refund_status === 'Under_review'
                                ? md5(item.ticketnumber)
                                : (item.qr_payload ?? '')
                            }
                            logoSize={30}
                            fgColor={
                              item.refund_status === 'Approved' ||
                              item.refund_status === 'Pending' ||
                              item.refund_status === 'Under_review'
                                ? 'grey'
                                : '#000'
                            }
                            bgColor={'#fff'}
                            className={'preview_tickets_qrcode'}
                          /> */}
                        </div>

                        <div className="pv-info">
                          <div className="pv-info__top">
                            <span className="pv-type">{category} admission</span>
                            <span className="pv-num">#{item.ticketnumber}</span>
                          </div>

                          <dl className="pv-facts">
                            <div>
                              <dt>Admissions</dt>
                              <dd>{item.quantity}</dd>
                            </div>
                            <div>
                              <dt>Price</dt>
                              <dd>
                                R
                                {Number(item.age_group == 1 ? item.kids_price : item.price).toFixed(
                                  2,
                                )}{' '}
                                x {item.quantity}
                              </dd>
                            </div>
                            <div>
                              <dt>Issued On</dt>
                              <dd>{item.created_at}</dd>
                            </div>
                            <div>
                              <dt>Time of Issue</dt>
                              <dd>{item.time_at}</dd>
                            </div>
                          </dl>

                          {!isVoid && (
                            <span className="pv-hint">
                              Tap to prepare for scanning <BiChevronRight size={16} />
                            </span>
                          )}
                        </div>
                      </Link>

                      {!refundHidden && (
                        <footer className="pv-card__foot">
                          <div className="pv-attempts">
                            {item.refund_status !== null ? (
                              <span className="pv-badge">
                                Refund {item.refund_status.replace('_', ' ').toLowerCase()}
                              </span>
                            ) : (
                              ''
                            )}
                            <span>
                              {attempts}/{item.maxAttempts} Attempts
                            </span>
                          </div>

                          <span
                            className={
                              Number(item.age_group == 1 ? item.kids_price : item.price) <= 0
                                ? 'd-none'
                                : ''
                            }
                          >
                            <button
                              type="button"
                              onClick={() =>
                                !item.qr_payload
                                  ? alert('This pass is invalid. Refunds are not available.')
                                  : refund(
                                      item.ticket_id,
                                      item.ticketnumber,
                                      item.event_name,
                                      item.event_id,
                                      item.refund_status,
                                      item.m_payment_id,
                                      attempts,
                                      item.maxAttempts,
                                    )
                              }
                              className={
                                !item.qr_payload
                                  ? 'pv-btn pv-btn--off'
                                  : item.refund_status === 'Pending' ||
                                      item.refund_status === 'Under_review'
                                    ? 'pv-btn pv-btn--warn'
                                    : item.refund_status === 'Approved' ||
                                        attempts === item.maxAttempts
                                      ? 'pv-btn pv-btn--off'
                                      : 'pv-btn pv-btn--primary'
                              }
                              disabled={
                                item.refund_status === 'Approved' ||
                                (item.refund_status !== 'Pending' && attempts === item.maxAttempts)
                                  ? true
                                  : false
                              }
                            >
                              {!item.qr_payload
                                ? 'QR code invalid'
                                : item.refund_status === 'Pending' ||
                                    item.refund_status === 'Under_review'
                                  ? 'Cancel Request'
                                  : item.refund_status === 'Approved'
                                    ? `${item.refund_status}`
                                    : 'Request Refund'}
                            </button>
                          </span>
                        </footer>
                      )}
                    </article>
                  )
                })}
              </div>
            )}
          </>
        )}
      </div>
    )
  }

  const handleToggle = () => {
    setCollapsed((prev) => !prev)
  }

  return (
    <div className="view">
      <Header />
      <SideNavCust collapsed={collapsed} onToggle={handleToggle} />

      {/* ✅ Mobile overlay when sidebar is open */}
      {isMobile && !collapsed && <div className="mobile-overlay active" onClick={handleToggle} />}

      {isMob && collapsed && (
        <label className="mobile-toggle" onClick={handleToggle}>
          <BiMenu size={25} />
        </label>
      )}

      <main
        className="pv-page"
        style={{
          marginTop: 'var(--header-h)',
          marginLeft: isMob ? 0 : collapsed ? '76px' : '252px',
        }}
      >
        <div className="pv-container">
          <button type="button" className="pv-back" onClick={() => history.goBack()}>
            <IoIosArrowBack size={18} />
            <span>Back</span>
          </button>

          <div className="pv-head">
            <h1>{eventname}</h1>

            <div className="pv-head__meta">
              {location.state?.eventday && (
                <span>
                  <IoCalendarOutline /> {location.state.eventday}
                </span>
              )}
              {location.state?.eventtime && (
                <span>
                  <IoTimeOutline /> {location.state.eventtime}
                </span>
              )}
              {location.state?.venue && (
                <span>
                  <IoLocationOutline /> {location.state.venue}
                </span>
              )}
            </div>
          </div>

          {loadingAttempts ? (
            <div className="text-center w-100 mb-3">
              <ClipLoader size={25} color="grey" />
            </div>
          ) : (
            <>
              {refundsAllowed == 0 && postponedCancelled === 'no' && (
                <div className="pv-banner pv-banner--danger">
                  {/* <IoWarningOutline size={20} /> */}
                  <div>
                    <strong>Refunds are not available for this event.</strong>
                    <span>
                      The organizer has chosen to disable refund requests across all ticket types.
                    </span>
                  </div>
                </div>
              )}

              {postponedCancelled === 'yes' && (
                <div className="pv-banner pv-banner--info">
                  <IoInformationCircleOutline size={20} />
                  <div>
                    <strong>
                      This event has been {postponed === 'yes' ? 'postponed' : 'cancelled'}.
                    </strong>
                    <span>You are entitled to a full refund.</span>
                  </div>
                </div>
              )}
            </>
          )}

          <p className="pv-count">CLICK TO PREPARE FOR SCANNING</p>

          {getTickets()}
        </div>
      </main>

      <div className="error-login" style={{ display: errorDisplay, textAlign: 'center' }}>
        {error}
      </div>
    </div>
  )
}

export default Previewtickets
